module.exports = __webpack_public_path__ + "img/HSBC.9ced43b2.svg";